/**
 * Determines if a column should be hidden in a DataGrid
 * @param {boolean|undefined} keyValue - The stored visibility value
 * @param {boolean} hideByDefault - Whether the column should be hidden by default
 * @returns {boolean}
 */
export const isColumnHidden = (keyValue, hideByDefault) => {
  if (keyValue === true) return false;       // Column is visible
  if (keyValue === false) return true;       // Column is not visible
  if (hideByDefault) return true;            // Column is not visible by default
  return false;                              // Column is visible
};